import React from "react";
import { classnames } from "@culturehq/components";

type PageOnClick = (page: number) => void;
type PageLinkProps = {
  disabled?: boolean;
  children: React.ReactNode;
  current?: boolean;
};

const PageLink: React.FC<PageLinkProps> = ({
  children, current, disabled
}) => (
  <span
    aria-current={current}
    className="Nav-simple"
  >
    {children}
  </span>
);

type PageProps = Omit<PageLinkProps, "children">;

const Page: React.FC<PageProps> = ({ children, ...props }) => (
  <PageLink {...props}>
    {children}
  </PageLink>
);

type PaginationProps = {
  className?: string;
  currentPage: number;
  onClick: PageOnClick;
  totalPages: number;
  smallVersion?: boolean;
};

const IconsPaginationSimple: React.FC<PaginationProps> = ({
  className,
  currentPage = 1,
  totalPages
}) => {
  if (totalPages < 2) {
    return null;
  }

  const innerWindow = [...Array(totalPages)].map((_, index) => index + 1);

  return (
    <nav className={classnames("chq-pag", "chq-icon-pag-simple", className)}>
      <div className="flx-row-simple">
        {innerWindow.map(page => (
          <Page key={page} current={page === currentPage} />
        ))}
      </div>
    </nav>
  );
};

export default IconsPaginationSimple;
